import {
    createLoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { startAppListening } from '../container/App/listener';
import { selectLoading } from '../container/App/selectors';

/**
 * Mount loading spinner
 */
export default function mountLoadingSpinner (id: string): LoadingSpinner | null {
    const container = document.getElementById(id);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const loadingSpinner = createLoadingSpinner(container, {
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: {},
    });

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectLoading(currentState) !== selectLoading(previousState),
        effect: (action, listenerApi) => {
            const isLoading = selectLoading(listenerApi.getState());

            loadingSpinner?.toggle(isLoading);
        },
    });

    return loadingSpinner;
}
